/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */

import { api } from 'utils/index';

const defaultState = {
    items: [], item: {}, meta: {}, saved: false, errors: null,
};

const model = {
    name: 'ingredient',
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data, meta: payload.meta }),
        findResponse: (state, payload) => ({ ...state, item: payload }),
        saveResponse: (state, payload) => {
            if (payload.errors) {
                return { ...state, saved: false, errors: payload.errors };
            }

            return { ...state, saved: true, item: payload };
        },
    },
    effects: {
        async fetch(params) {
            await api.get('ingredients', params)
                .then(response => this.fetchResponse(response));
        },
        async find(params) {
            await api.get(`ingredients/${params}`, params)
                .then(response => this.findResponse(response));
        },
        async save(data) {
            await api.post('ingredients', data)
                .then(response => this.saveResponse(response));
        },
        async saveStock(data) {
            await api.post(`ingredients/${data.id}/stocks`, data)
                .then(response => this.saveResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, state => state.ingredient, ingredient => ingredient.items);
        },
    }),
};

export default model;
